function tsvExport() {

    onmessage = function (message) {
        const { data, options, format } = message.data;
        let tsvData = tsvFunction(data, options, format);
        postMessage(tsvData);
        // Clear the data
        tsvData = undefined;
    };

    function escapeText(text) {
        if (!text) return "";
        text = text.replace(/\\/g, '\\\\');
        text = text.replace(/\n/g, "\\n");
        text = text.replace(/\t/g, "\\t");
        text = text.replace(/\r/g, "\\r");
        return text;
    }

    function computeRows(data) {

        const columns = data.head.vars;
        const tsvData = data.results.bindings.map(row => columns.map(col => row[col] && row[col].value ?
            escapeText(row[col].value)
            :
            ""));
        return tsvData;
    }

    function computeHeaders(data) {
        const columns = data.head.vars;
        const tsvData = columns.map(column => column.replace(/_/g, ' '));
        return tsvData;
    }

    function tsvFunction(data, options, format = "tsv") {
        if (format === "tsv") {
            const headers = options.includeHeaders ? computeHeaders(data).join("\t") + "\n" : "";
            const rowData = computeRows(data);
            const finalData = rowData.map(row => row.join("\t")).join("\n");
            return headers + finalData;
        }
        const finalData = computeRows(data);
        if (!options.includeHeaders) {
            return finalData;
        }
        else {
            let headers = [computeHeaders(data)];
            return headers.concat(finalData);
        }

    }

}

export default tsvExport;